// Styles partagés et réutilisables
export const colors = {
    primary: '#142D55',
    secondary: '#78AA5A',
    text: '#555C66',
    white: '#FFFFFF',
    lightGray: 'rgba(85, 92, 102, 0.1)',
    darkBg: '#142D55',
    lightBlueBg: 'rgba(20, 45, 85, 0.08)',
};

export const globalStyles = `
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
  }

  html {
    scroll-behavior: smooth;
  }

  body {
    background-color: ${colors.white};
    color: ${colors.text};
    line-height: 1.6;
  }

  header {
    transition: all 0.3s ease;
  }

  header.scrolled {
    background: rgba(255, 255, 255, 0.95);
    backdrop-filter: blur(10px);
    border-bottom: 1px solid rgba(20, 45, 85, 0.1);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }

  .btn-primary {
    background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primary} 100%);
    color: ${colors.white};
    padding: 12px 28px;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.3s ease;
    border: none;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .btn-primary:hover {
    transform: translateY(-2px);
    box-shadow: 0 12px 24px rgba(20, 45, 85, 0.3);
  }

  .btn-secondary {
    background: transparent;
    color: ${colors.primary};
    border: 2px solid ${colors.primary};
    padding: 10px 24px;
    border-radius: 6px;
    font-weight: 600;
    transition: all 0.3s ease;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 8px;
  }

  .btn-secondary:hover {
    background: rgba(20, 45, 85, 0.05);
    transform: translateY(-2px);
  }

  .service-card {
    border: 1px solid ${colors.lightGray};
    border-radius: 8px;
    padding: 32px 24px;
    transition: all 0.3s ease;
    background: ${colors.white};
  }

  .service-card:hover {
    border-color: ${colors.primary};
    box-shadow: 0 20px 40px rgba(20, 45, 85, 0.08);
    transform: translateY(-8px);
  }

  .form-input {
    background: transparent;
    border: none;
    border-bottom: 2px solid rgba(85, 92, 102, 0.2);
    padding: 12px 0;
    font-size: 16px;
    color: ${colors.text};
    transition: all 0.3s ease;
    font-family: inherit;
    width: 100%;
  }

  .form-input:focus {
    outline: none;
    border-bottom-color: ${colors.primary};
    background: rgba(20, 45, 85, 0.02);
    padding-left: 8px;
    padding-right: 8px;
  }

  .form-input::placeholder {
    color: ${colors.text};
  }

  .gradient-text {
    background: linear-gradient(135deg, ${colors.primary} 0%, ${colors.primary} 100%);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .stat-number {
    font-size: 3.5rem;
    font-weight: 800;
    line-height: 1;
  }

  .fade-in-up {
    opacity: 0;
    transform: translateY(40px);
  }

  @keyframes bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
  }

  .animate-bounce {
    animation: bounce 2s infinite;
  }
`;
